import { render, staticRenderFns } from "./EventPackages.vue?vue&type=template&id=006d27e0&"
import script from "./EventPackages.vue?vue&type=script&lang=js&"
export * from "./EventPackages.vue?vue&type=script&lang=js&"
import style0 from "./EventPackages.vue?vue&type=style&index=0&id=006d27e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports